import { Provider } from "@angular/core";
import { LuxonDateAdapter, MAT_LUXON_DATE_ADAPTER_OPTIONS } from "@angular/material-luxon-adapter";
import { DateAdapter } from "@angular/material/core";

export function provideLuxonDateAdapterOptions(): Provider[] {
    return [{ provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true, strict: true } }];
}
